import type { PortalProfile } from '@/portal/api/portalApi';

export interface HomeVisitPrefill {
  name: string;
  code: string;
  phone1: string;
  phone2: string;
  age: string;
  address: string;
}

export const homeVisitPrefillFromProfile = (profile: PortalProfile | null): HomeVisitPrefill => ({
  name: profile?.displayName.trim() ?? '',
  code: profile ? String(profile.customerId) : '',
  phone1: profile?.phone.trim() ?? '',
  phone2: profile?.secondaryPhone.trim() ?? '',
  age: profile?.age ? String(profile.age) : '',
  address: profile?.address.trim() ?? '',
});

/** Identity fields that came from the account and must not be edited in the request form. */
export const lockedPrefillFields = (prefill: HomeVisitPrefill): ReadonlySet<keyof HomeVisitPrefill> =>
  new Set((['name', 'code', 'phone1', 'phone2', 'age'] as const).filter((field) => prefill[field] !== ''));
